import React from 'react';
import { PropTypes } from 'prop-types';

import './AccordionItem.scss';

const AccordionItem = ({
  title,
  content,
  icon,
  showContent,
  toggle,
  image,
  // setShowContent,
}) => (
  <div className="accordion-item">
    <button type="button" className="accordion-button" onClick={toggle}>
      <span>
        <img src={icon} alt="" /> {title}
      </span>
    </button>
    {showContent && (
      <>
        <p className="content">
          {content}
          <img className="mx-auto visible-mobile" src={image} alt="" />
        </p>
      </>
    )}
  </div>
);

export default AccordionItem;

AccordionItem.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  icon: PropTypes.string,
  showContent: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  image: PropTypes.string,
  // setShowContent: PropTypes.func,
};
